module.exports = __webpack_public_path__ + "img/poweroff.0b60d097.svg";